export default "__VITE_ASSET__7f941530__"